import { useFormContext, Controller } from "react-hook-form";

import EmployeeSelect from "./EmployeeSelect";

const ManagerField = () => {
  const {
    formState: { errors },
    control,
  } = useFormContext();

  return (
    <>
      <label
        htmlFor="manager-id"
        className="block text-sm font-medium leading-5 text-gray-900"
      >
        Vorgesetzter
      </label>
      <Controller
        control={control}
        name="managerId"
        render={({ field }) => <EmployeeSelect {...field} />}
      />
    </>
  );
};

export default ManagerField;
